import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import RemoteList from "../Helpers/RemoteList";
import {ComponentContext} from "../../contexts";
import reactionCombiner from "../../utils/reactionCombiner";
import ElementSelector from "../Helpers/ElementSelector";
import DataExporter from "../Helpers/DataExporter";
import SectionSelector from "../Helpers/SectionSelector";
import FullList from "../Helpers/FullList";

function DynamicSelect(props) {
  let _inputRef;
  const store = useLocalObservable(() => ({focused:false, popup_select:false}));
  const compStore=useContext(ComponentContext);
  let comb=null;
  let _TA_iconChange=null;

  useEffect(() => {
    // mount
    if(!comb) {
      let _inputRef=null;
      comb=new reactionCombiner();

      comb.addReaction(()=>{
        return getValue()?getValue().focus:null;
      },(focus)=>{
        if(focus) {
          if(_inputRef) {
            _inputRef.focus();
          }
        }
      },{fireImmediately:true})
    }
    if(!compStore.data) {
      runInAction(()=>{
        compStore.data={value:''};
      });
    }
    return () => {
      // unmount
    }
  }, []);

  const field={
    title_field:"name",
    list_route: `/eva2/ajax/ajaxTableApi.php?operation=getBlenderAll&category=${props.category}&type=\\Eva\\dynamicSectionBlender`,
    search_field: "~name",
    visible_fields: ["name"]
  }

  if(!compStore.data) {
    return null;
  }

  const refChanged=(ref)=>{
    if(ref) {
      if (getValue().focus) {
        ref.focus();
        _inputRef = ref;
        setTimeout(() => {
          getValue().focus = 0;
        }, 100);
      }
    }
  };

  const selectValue=()=>{
    if(typeof props.index !== "undefined") {

    } else {

    }
  };
  const getValue=()=> {
    if(typeof props.index !== "undefined") {
      return compStore.data[props.index]
    } else {
      return compStore.data;
    }
  };

  return (
    <div>
      <div className="up12 splice">
        <div className="cell s-shrink"></div>
        <div className="cell s-auto">
          <FullList
            placeholder={compStore.options.placeholder}
            locked={false}
            field={field}
            item={getValue()}
            inputRef={(ref)=>{ refChanged(ref); _inputRef=ref; }}
            onNewFied={()=>{
              // this.context.searchStore.blocks.push({code: '', compare: '', value: '', focus:0});
            }}
            onLock={()=>{
              // this.lockMe();
            }}
            onKeyDown={(e)=> {
              /*
              if(e.shiftKey && e.ctrlKey && e.which == 76 && this.props.item.value) {
                e.preventDefault();
                e.stopPropagation();
                this.lockMe();
              }

              if (e.which === 8) {
                if (!this.props.item.value) {
                  e.preventDefault();
                  e.stopPropagation();
                  this.removeMe();
                }
              }
              if (e.which === 191 || e.which === 220) {
                e.preventDefault();
                e.stopPropagation();
                this.context.searchStore.blocks.push({code: '', compare: '', value: '', focus: 0});
              }
               */
            }}
            onCancel={()=> {

            }}
            onSelect={(item)=>{
              runInAction(()=>{
                getValue().value=item.value;
                getValue().focus=1;
                _inputRef.focus();
              });
              /*
              console.log("focus on select");
              this.props.item.value=item.value;
              this.props.item.focus=1;
              */
            }}
            onFocus={()=>{
              console.log("FOCUS FIRE");
              clearTimeout(_TA_iconChange);
              runInAction(()=>{ store.focused=true; });
            }}
            onBlur={()=>{
              console.log("BLUR FIRE");
              clearTimeout(_TA_iconChange);
              _TA_iconChange=setTimeout(()=>{
                runInAction(()=>{
                  store.focused=false;
                });
              },200);
            }}
          />
        </div>
        <div className="cell s-shrink s-middle pleft5">
          {store.focused || typeof props.index === 'undefined'?(
            <span className="pc1 mdi mdi-open-in-new fs20 lh10 pointer" onClick={()=>{
              runInAction(()=>{ store.popup_select=true; });
            }}></span>
          ):(
            <span className="w4 const1-hover mdi mdi-trash-can-outline fs20 lh10 pointer" onClick={()=>{
              if(typeof props.index !== 'undefined') {
                props.deleteMe();
              } else {
                runInAction(()=>{
                  getValue().value='';
                });
              }
            }}></span>
          )}
        </div>
      </div>
      {store.popup_select?(
        <SectionSelector
          category={props.category}
          hidePopup={()=>{ runInAction(()=>{ store.popup_select=false; });  }}
          onChange={(newVal)=>{ getValue().value=newVal; }}
        />
      ):null}
      {typeof props.index === "undefined"?(
        <DataExporter exportIndex="value" plain={true} />
      ):null}
    </div>
  )
};

DynamicSelect.defaultProps = {};

DynamicSelect.propTypes = {}

export default observer(DynamicSelect);
